import React, { useRef, useState } from "react";
import Slider from "react-slick";
import SliderCard from "./SliderCard";
import { Btn2 } from "../common/btn";

const Collections = ({ data }) => {
  let slider = useRef(null);
  const [activeProduct, setActiveProduct] = useState(0);
  setTimeout(() => {
    if (activeProduct === data.locations.length - 1) {
      setActiveProduct(0);
    } else {
      setActiveProduct(activeProduct + 1);
    }
  }, 4000);

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 700,
    loop: true,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 990,

        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 860,
        settings: {
          dots: true,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          dots: true,
          className: "slider variable-width",
          // variableWidth: true,
          slidesToShow: 1,
        },
      },
    ],
  };

  function handlePrev() {
    slider?.current?.slickPrev();
  }

  function handleNext() {
    slider?.current?.slickNext();
  }

  return (
    <div
      className="max-w-7xl w-full mx-auto overflow-hidden py-5 sm:py-10 px-5 sm:px-10"
      id={data.sectionId}
    >
      <div className="space-y-3 flex flex-col items-center text-center mb-5">
        <h2 className="text-2xl sm:text-4xl w-fit font-bold flex items-center justify-center">
          {data.leftIcon && (
            <img
              src={data.leftIcon.asset.url || "/placeholder.svg"}
              alt=""
              className="w-9 sm:w-12 h-9 sm:h-12 mr-2 object-contain"
            />
          )}
          {data.title}
          {data.rightIcon && (
            <img
              src={data.rightIcon.asset.url || "/placeholder.svg"}
              alt=""
              className="w-9 sm:w-12 h-9 sm:h-12 ml-2 object-contain"
            />
          )}
        </h2>
        <p className="text-lg sm:text-xl max-w-3xl mx-auto">{data.subTitle}</p>
      </div>

      <div className="w-full flex justify-center mb-5">
        <Btn2 data={data.button} />
      </div>

      {/* Slider */}
      <div className="block w-full mx-auto relative px-3 md:px-5 mb-5 md:mb-0">
        <button
          className="hidden md:block absolute top-1/2 left-2 2xl:-left-6 w-[18px] h-[18px] z-10"
          onClick={handlePrev}
          aria-label="Previous Location"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="20"
            viewBox="0 0 19 20"
            fill="none"
            className="rotate-180"
            role="presentation"
          >
            <path
              d="M8.83276 1L17.6654 9.83265L8.83276 18.6653"
              stroke="black"
              stroke-linecap="round"
            />
          </svg>
        </button>
        <Slider {...sliderSettings} ref={slider}>
          {data.locations.map((location, index) => (
            <SliderCard key={index} location={location} index={index} />
          ))}
        </Slider>
        <button
          className="hidden md:block absolute top-1/2 right-2 2xl:-right-6 w-[18px] h-[18px] z-10"
          onClick={handleNext}
          aria-label="Next Location"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="20"
            viewBox="0 0 19 20"
            fill="none"
            role="presentation"
          >
            <path
              d="M8.83276 1L17.6654 9.83265L8.83276 18.6653"
              stroke="black"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Collections;
